<template>
  <v-dialog persistent v-model="isDialogOpen" max-width="450">
    <v-card max-width="450" class="mx-auto">
      <div class="px-3 pt-3 mb-0 d-flex justify-end">
        <v-icon class="cursor-pointer" @click="closeLikeList">mdi-close</v-icon>
      </div>
      <v-list ref="scrollContainer" class="scroll-container">
        <div v-for="(item, index) in displayedLikes" :key="index" class="px-2">
          <v-list-item dense>
            <v-list-item-avatar
              width="30"
              height="30"
              min-height="30"
              min-width="30"
              color="grey"
            >
              <v-img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                :alt="`${item.name} ${item.lastName}`"
                :lazy-src="require('../../assets/images/lazy-loading.png')"
              >
              </v-img>
              <div v-else>{{ getUserInitials(item.name, item.lastName) }}</div>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{
                `${item.name} ${item.lastName}`
              }}</v-list-item-title>
            </v-list-item-content>
            <v-icon class="red--text caption">mdi-heart</v-icon>
          </v-list-item>
          <v-divider v-if="displayedLikes.length - 1 != index"></v-divider>
        </div>
        <!-- This is the observer trigger -->
        <div ref="loadMoreTrigger" class="load-more-trigger"></div>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import helpers from "@/plugins/helpers";

export default {
  name: "LikesDialog",
  props: {
    likeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      displayedLikes: [],
      itemsPerPage: 10,
      observer: null,
    };
  },
  computed: {
    isDialogOpen() {
      return this.likeList.length > 0;
    },
  },
  watch: {
    likeList: {
      immediate: true,
      handler(newList) {
        this.displayedLikes = newList.slice(0, this.itemsPerPage);
        this.$nextTick(() => this.setupIntersectionObserver());
      },
    },
  },
  methods: {
    closeLikeList() {
      this.$emit("closeLikeList");
    },
    getUserInitials(name, lastName) {
      return helpers.getInitials(name, lastName);
    },
    loadMore() {
      if (this.displayedLikes.length >= this.likeList.length) return;

      const nextItems = this.likeList.slice(
        this.displayedLikes.length,
        this.displayedLikes.length + this.itemsPerPage
      );
      this.displayedLikes = [...this.displayedLikes, ...nextItems];
    },
    setupIntersectionObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.$nextTick(() => {
        const trigger = this.$refs.loadMoreTrigger;
        if (!trigger) {
          console.warn("loadMoreTrigger not found in DOM!");
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.loadMore();
          }
        });

        this.observer.observe(trigger);
      });
    },
  },
  mounted() {
    this.loadMore();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style>
.scroll-container {
  max-height: 400px;
  overflow-y: auto;
}

.load-more-trigger {
  height: 20px; /* Small spacer to trigger observer */
}
</style>
